import { Link } from 'react-router-dom'

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 mb-8"
        >
          <i className="fas fa-arrow-left"></i>
          Back to Login
        </Link>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
          <p className="text-gray-500 dark:text-gray-400 mb-8">Last updated: January 2025</p>

          <div className="prose dark:prose-invert max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">1. Information We Collect</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Jasmine Dental Lab collects information necessary to provide our dental lab services, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>Contact information (name, email, phone number)</li>
              <li>Business information (clinic name, GST number, PAN number)</li>
              <li>Work order details including optional patient names provided by dental professionals</li>
              <li>Payment and billing information</li>
              <li>Usage data and system logs</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We use the collected information to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>Process and fulfill dental lab work orders</li>
              <li>Generate invoices and process payments</li>
              <li>Communicate about orders, deliveries, and services</li>
              <li>Improve our services and user experience</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">3. Data Security</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We implement industry-standard security measures to protect your data, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>Encryption of data in transit and at rest</li>
              <li>Secure authentication mechanisms</li>
              <li>Regular security audits and updates</li>
              <li>Access controls and audit logging</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">4. Data Retention</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We retain your data for as long as necessary to provide our services and comply with legal
              obligations. Financial records are retained as required by Indian tax laws.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">5. Your Rights</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data (subject to legal requirements)</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">6. Contact Us</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              For privacy-related inquiries, please contact us at:
            </p>
            <p className="text-gray-600 dark:text-gray-300">
              <strong>Email:</strong> privacy@jasminedental.com<br />
              <strong>Phone:</strong> +91 98765 43210<br />
              <strong>Address:</strong> Jasmine Dental Lab, Bangalore, Karnataka, India
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
